const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTouchdesignerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1137 1137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01699,0,0,1.01699,-7.65071,-7.62746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.5,305.5C487.996,312.562 442.663,331.895 402.5,363.5C371.812,333.146 341.146,302.812 310.5,272.5L310.5,147.5L148.5,147.5L148.5,309.5L273.5,309.5C304.339,339.506 334.672,370.006 364.5,401C330.182,444.423 310.848,493.923 306.5,549.5C305.834,555.157 305.501,560.99 305.5,567C305.376,576.709 306.042,586.209 307.5,595.5C313.391,646.371 332.224,691.705 364,731.5C364.667,732.167 364.667,732.833 364,733.5C333.833,763.667 303.667,793.833 273.5,824C231.835,824.5 190.168,824.667 148.5,824.5L148.5,985.5L310.5,985.5C310.333,943.832 310.5,902.165 311,860.5C340.833,830.667 370.667,800.833 400.5,771C401.5,770.333 402.5,770.333 403.5,771C444.31,803.89 490.976,822.724 543.5,827.5L543.5,1099.5L36.5,1099.5L36.5,35.5L542.5,35.5L542.5,304.5C540.901,304.232 539.568,304.566 538.5,305.5Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01699,0,0,1.01699,-7.65071,-7.62746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1099.5,1099.5L592.5,1099.5L592.5,827.5C630.947,823.72 666.947,812.22 700.5,793C712.061,785.253 723.395,777.587 734.5,770C764.667,800.167 794.833,830.333 825,860.5C825.5,902.165 825.667,943.832 825.5,985.5L987.5,985.5L987.5,824.5C945.832,824.667 904.165,824.5 862.5,824C832.333,793.833 802.167,763.667 772,733.5C771.333,732.833 771.333,732.167 772,731.5C803.776,691.705 822.609,646.371 828.5,595.5C829.958,586.209 830.624,576.709 830.5,567C830.499,560.99 830.166,555.157 829.5,549.5C825.161,493.958 805.828,444.458 771.5,401C801.328,370.006 831.661,339.506 862.5,309.5L987.5,309.5L987.5,147.5L825.5,147.5C825.827,189.572 825.494,231.572 824.5,273.5C794.188,303.479 763.854,333.479 733.5,363.5C692.127,330.652 645.127,311.319 592.5,305.5C598.167,305.336 598.5,305.003 593.5,304.5L593.5,35.5L1099.5,35.5L1099.5,1099.5Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01699,0,0,1.01699,-7.65071,-7.62746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.5,353.5C627.216,351.212 688.383,378.545 736,435.5C779.675,495.2 791.342,560.866 771,632.5C745.12,703.214 696.287,749.88 624.5,772.5C557.123,789.053 495.456,777.219 439.5,737C365.547,675.798 340.38,598.298 364,504.5C377.855,463.069 401.355,428.403 434.5,400.5C455.949,383.904 479.616,371.404 505.5,363C521.317,359.151 536.984,355.985 552.5,353.5ZM507.5,506.5L507.5,627.5L628.5,627.5L628.5,506.5L507.5,506.5Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchdesignerLogo);
export default __webpack_public_path__ + "static/media/touchdesigner_logo.cda18bf532f99eec8a7ac1c7ac674328.svg";
export { ForwardRef as ReactComponent };